import { render, staticRenderFns } from "./noseGroup.vue?vue&type=template&id=c2c14de0&scoped=true"
import script from "./noseGroup.vue?vue&type=script&lang=js"
export * from "./noseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c14de0",
  null
  
)

export default component.exports